import { render } from "./AgreementForm.vue?vue&type=template&id=63fca494&scoped=true"
import script from "./AgreementForm.vue?vue&type=script&lang=js"
export * from "./AgreementForm.vue?vue&type=script&lang=js"

import "./AgreementForm.vue?vue&type=style&index=0&id=63fca494&scoped=true&lang=css"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fca494"]])

export default __exports__